import React from 'react';
import {
    Footer as LayoutComponentFooter,
    useShellContext
} from '@vtblife/layout-components';
import { MenuItemComponentProps } from '@vtblife/layout-components/dist/types/menu-item.interface';
import {
    FooterLink,
    FooterMiddleCol,
    FooterPhoneType,
} from '@vtblife/layout-components/dist/types/footer.interface';
import { FooterLink as FooterLinkConfig } from '@vtblife/layout-config/dist/types';

import { errorCatcherWrap } from '@search/error/src/catcher';

import { ClShellConfigContext, useCustomConfig } from '../ClShellProvider';

const FooterMenuItemComponent: React.FC<MenuItemComponentProps> = props => {
    const { url = '/', path, ...rest } = props;

    return <a key={url} href={url === 'undefined' ? path : url} {...rest} />;
};

const ClFooter: React.FC<{
    buildLink?: (url: string) => string;
    phone?: FooterPhoneType;
    regionId?: number;
}> = ({ regionId, ...props }) => {
    const { config } = useShellContext() as unknown as { config: ClShellConfigContext };

    // Костыль, не работает useShellContext
    const shellConfig = useCustomConfig();

    // eslint-disable-next-line max-len
    const { top, middleLinks: rawMiddleLinks, downloadAppQrCode, socialLinks = [] } = (config ?? shellConfig)?.footer || {};

    const buildLink = (link: FooterLinkConfig) => {
        const url = (link.to || link.href) as string;
        const absoluteUrl = props.buildLink ? props.buildLink(url) : url;

        return {
            ...link,
            href: link.cdn ? url : absoluteUrl
        };
    };

    const topLinks: Array<Array<FooterLink>> = (top || [])
        .map(links => (links || [])
            .map(link => buildLink(link as FooterLinkConfig))
        );

    const middleLinks: Array<FooterMiddleCol> = (rawMiddleLinks || [])
        .map(column => ({
            title: column!.title,
            links: (column!.links || []).map(link => buildLink(link as FooterLinkConfig))
        }));

    return (
        <LayoutComponentFooter
            top={topLinks}
            middle={middleLinks}
            menuItemComponent={FooterMenuItemComponent}
            phone={props.phone}
            socialLinks={socialLinks}
            downloadAppQrCode={downloadAppQrCode}
        />
    );
};

export default errorCatcherWrap(ClFooter);
